var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0b5089",
    d: "m0,0h1600v1000h-1600z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m500,0h200v1000h-200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0,400h1600v200h-1600z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSe);
export default __webpack_public_path__ + "static/media/SE.b1a385dc497f323c1eb874a3aeca0287.svg";
export { ForwardRef as ReactComponent };